<template>
  <a-layout>
    <div>
      <a-button type="primary" @click="exportBaseData">{{ $t('button.expConfirm') }}</a-button>
      &nbsp;&nbsp;&nbsp;
      <a-button @click="save" type="primary">{{ $t('button.save') }}</a-button>
      &nbsp;&nbsp;&nbsp;
      <a-button type="primary" @click="clear">{{ $t('button.clear') }}</a-button>
      &nbsp;&nbsp;&nbsp;
      <!--      <a-button type="primary" @click="query">{{ $t('button.query') }}</a-button>-->
      &nbsp;&nbsp;&nbsp;
      <!--      操作数据: action: '操作',-->
      {{$t('business.label.action')}}
      <a-select defaultValue="商品资料" style="width: 160px" @change="handleChange">
        <a-select-option value="item">商品资料</a-select-option>
        <a-select-option value="itemPack">商品包装资料</a-select-option>
        <a-select-option value="itemModel">商品版本资料</a-select-option>
        <a-select-option value="locationForItem">货位品种关系维护</a-select-option>
        <a-select-option value="customer">客户资料</a-select-option>
        <a-select-option value="supplier">供应商资料</a-select-option>
        <a-select-option value="location">货位资料</a-select-option>
      </a-select>
      <a-upload
        name="file"
        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        :beforeUpload="beforeUpload"
      >
        <a-button type="primary">
          <a-icon type="upload"/>
          {{ $t('button.impConfirm') }}
        </a-button>
      </a-upload>
    </div>
    <ItemBaseData ref="itemBaseData" v-show="isItem" @sendSave="sendSave"></ItemBaseData>
    <ItemPackBaseData ref="itemPackBaseData" v-show="isItemPack" @sendSave="sendSave"></ItemPackBaseData>
    <ItemModelBaseData ref="itemModelBaseData" v-show="isItemModel" @sendSave="sendSave"></ItemModelBaseData>
    <LocationForItemBaseData @sendSave="sendSave" ref="locationForItemBaseData"
                             v-show="isLocationForItem"></LocationForItemBaseData>
    <CustomerBaseData ref="customerBaseData" v-show="isCustomer" @sendSave="sendSave"></CustomerBaseData>
    <SupplierBaseData ref="supplierBaseData" v-show="isSupplier" @sendSave="sendSave"></SupplierBaseData>
    <LocationBaseData ref="locationBaseData" v-show="isLocation" @sendSave="sendSave"></LocationBaseData>
  </a-layout>
</template>

<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'
import ItemBaseData from '@/views/basedata_import/ItemBaseData'
import ItemPackBaseData from '@/views/basedata_import/ItemPackBaseData'
import ItemModelBaseData from '@/views/basedata_import/ItemModelBaseData'
import LocationForItemBaseData from '@/views/basedata_import/LocationForItemBaseData'
import CustomerBaseData from '@/views/basedata_import/CustomerBaseData'
import SupplierBaseData from '@/views/basedata_import/SupplierBaseData'
import LocationBaseData from '@/views/basedata_import/LocationBaseData'
import * as XLSX from 'xlsx'

export default {
    name: 'BaseDataImport',
    components: {
      LocationBaseData,
      SupplierBaseData,
      CustomerBaseData,
      LocationForItemBaseData,
      ItemModelBaseData,
      ItemPackBaseData,
      ItemBaseData
    },
    data() {
      return {
        isItem: false,
        isItemPack: false,
        isItemModel: false,
        isLocationForItem: false,
        isCustomer: false,
        isSupplier: false,
        isLocation: false,
        factory: '',
        activeTable: '',
        visible: false,
        importData: [],
        paramerer: {}
      }
    },
    mounted() {
      this.factory = 'itemFactory'
      this.activeTable = 'item'
      this.isItem = true
    },
    methods: {
      exportBaseData() {
        switch (this.activeTable) {
          case 'item':
            this.$refs.itemBaseData.exportData()
            break
          case 'itemPack':
            this.$refs.itemPackBaseData.exportData()
            break
          case 'itemModel':
            this.$refs.itemModelBaseData.exportData()
            break
          case 'locationForItem':
            this.$refs.locationForItemBaseData.exportData()
            break
          case  'customer':
            this.$refs.customerBaseData.exportData()
            break
          case  'supplier':
            this.$refs.supplierBaseData.exportData()
            break
          case  'location':
            this.$refs.locationBaseData.exportData()
            break
        }
      },
      beforeUpload(file) {
        let data = []// 存储获取到的数据
        // 通过FileReader对象读取文件
        const fileReader = new FileReader()
        fileReader.readAsBinaryString(file)  //二进制
        fileReader.onload = event => {
          try {
            const { result } = event.target
            // 以二进制流方式读取得到整份excel表格对象
            const workbook = XLSX.read(result, { type: 'binary' })
            // 遍历每张工作表进行读取（这里默认只读取第一张表）
            for (const sheet in workbook.Sheets) {
              if (workbook.Sheets.hasOwnProperty(sheet)) {
                // 利用 sheet_to_json 方法将 excel 转成 json 数据
                data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
                break // 如果只取第一张表，就取消注释这行
              }
            }
            this.transformData(data)
            // this.$message.info(JSON.stringify(data))
          } catch (e) {
            // 这里可以抛出文件类型错误不正确的相关提示
            console.log('文件类型不正确')
          }
        }
      },

      query() {
          findAll(this.factory, this.paramerer).then(body => {
          this.getWay(body)
        })
      },
      handleChange(values) {
        this.isItem = false
        this.isItemPack = false
        this.isItemModel = false
        this.isLocationForItem = false
        this.isCustomer = false
        this.isSupplier = false
        this.isLocation = false
        this.activeTable = values
        switch (values) {
          case 'item':
            this.isItem = true
            this.factory = 'itemFactory'
            this.paramerer = {}
            break
          case 'itemPack':
            this.isItemPack = true
            this.factory = 'packFactory'
            this.paramerer = {}
            break
          case 'locationForItem':
            this.isLocationForItem = true
            this.factory = 'locationLimitFactory'
            this.paramerer = {}
            break
          case  'customer':
            this.isCustomer = true
            this.factory = 'customerFactory'
            this.paramerer = { downstream: true }

            break
          case  'supplier':
            this.isSupplier = true
            this.factory = 'customerFactory'
            this.paramerer = { upstream: true }
            break
          case  'location':
            this.isLocation = true
            this.factory = 'locationFactory'
            this.paramerer = {}
            break
        }
      },
      getWay(data) {
        switch (this.activeTable) {
          case 'item':
            this.$refs.itemBaseData.getData(data)
            break
          case 'itemPack':
            this.$refs.itemPackBaseData.getData(data)
            break
          case 'itemModel':
            this.$refs.itemModelBaseData.getData(data)
            break
          case 'locationForItem':
            this.$refs.locationForItemBaseData.getData(data)
            break
          case  'customer':
            this.$refs.customerBaseData.getData(data)
            break
          case  'supplier':
            this.$refs.supplierBaseData.getData(data)
            break
          case  'location':
            this.$refs.locationBaseData.getData(data)
            break
        }
      },
      transformData(data) {
        switch (this.activeTable) {
          case 'item':
            this.$refs.itemBaseData.transformData(data)
            break
          case 'itemPack':
            this.$refs.itemPackBaseData.transformData(data)
            break
          case 'itemModel':
            this.$refs.itemModelBaseData.transformData(data)
            break
          case 'locationForItem':
            this.$refs.locationForItemBaseData.transformData(data)
            break
          case  'customer':
            this.$refs.customerBaseData.transformData(data)
            break
          case  'supplier':
            this.$refs.supplierBaseData.transformData(data)
            break
          case  'location':
            this.$refs.locationBaseData.transformData(data)
            break
        }
      },
      save() {
        this.$sign({
          reason: '字典资料维护',
          button: 'save',
          router: this.$route,
          click: () => {
            switch (this.activeTable) {
              case 'item':
                this.$refs.itemBaseData.save()
                break
              case 'itemPack':
                this.$refs.itemPackBaseData.save()
                break
              case 'itemModel':
                this.$refs.itemModelBaseData.save()
                break
              case 'locationForItem':
                this.$refs.locationForItemBaseData.save()
                break
              case  'customer':
                this.$refs.customerBaseData.save()
                break
              case  'supplier':
                this.$refs.supplierBaseData.save()
                break
              case  'location':
                this.$refs.locationBaseData.save()
                break
            }
          }
        })
      },
      clear() {
        switch (this.activeTable) {
          case 'item':
            this.$refs.itemBaseData.clear()
            break
          case 'itemPack':
            this.$refs.itemPackBaseData.clear()
            break
          case 'itemModel':
            this.$refs.itemModelBaseData.clear()
            break
          case 'locationForItem':
            this.$refs.locationForItemBaseData.clear()
            break
          case  'customer':
            this.$refs.customerBaseData.clear()
            break
          case  'supplier':
            this.$refs.supplierBaseData.clear()
            break
          case  'location':
            this.$refs.locationBaseData.clear()
            break
        }
      },
      sendSave(data) {
          post(api.saveAll, {}, data).then(response => {
          return this.$success({
            title: '提示',
            content: '保存成功'
          })
        }).catch(err => {
          this.requestFailed(err)
        })
      },
      requestFailed(err) {
        this.$notification['error']({
          message: '错误',
          description: (err.response || {}).data || err.message || '请求出现错误，请稍后再试',
          duration: 4
        })
      }
    }
  }
</script>

<style scoped>

</style>